import React from "react";
import { useEffect } from "react";
import { Container, Col, Row } from "react-bootstrap";
import "./Townhall.css";
import AOS from "aos";
import { Link } from "react-router-dom";
import townhall15 from "../assets/img/townhall15.png";
import townhall14 from "../assets/img/townhall14.png";
import townhall13 from "../assets/img/townhall13.png";
import townhall12 from "../assets/img/townhall12.png";
import townhall11 from "../assets/img/townhall11.png";
import townhall10 from "../assets/img/townhall10.png";
import townhall9 from "../assets/img/townhall9.png";

export default function TownHall() {
  useEffect(() => {
    AOS.init();
  }, []);
  return (
    <section className="townhall" id="townhall">
      <Container>
        <div className="align-items-center text-center mb-5">
          <h2
            style={{ fontSize: "28px" }}
            data-aos="fade-up-right"
            className="tbtn mt-4"
          >
            TownHall Links
          </h2>
        </div>

        <Row className="align-items-center">
          <div className="headline text-center mt-4">
            <button className="thlbtn">TownHall 15</button>
          </div>
          <Col xs={12} md={6} xl={5} data-aos="fade-up">
            <img src={townhall15} alt="Header img" />
          </Col>
          <Col xs={12} md={6} xl={7} className="px-5" data-aos="fade-up">
            <span className="tagline mt-4 ">War Base</span>
            <br />
            <Link
              to="https://link.clashofclans.com/en?action=OpenLayout&id=TH15%3AHV%3AAAAADAAAAAJYQwj0dofn_XP98hsv2cr8"
              target="_blank"
            >
              <button className="learn-more mb-2">
                <span className="hcircle" aria-hidden="true">
                  <span className="icon arrow"></span>
                </span>
                <span className="button-text">Link 1</span>
              </button>
            </Link>
            <br />

            <Link
              to="https://link.clashofclans.com/en?action=OpenLayout&id=TH15%3AHV%3AAAAADAAAAAJYQ0uuqQcgH_x-uXTdu8Nx"
              target="_blank"
            >
              <button className="learn-more mb-2">
                <span className="hcircle" aria-hidden="true">
                  <span className="icon arrow"></span>
                </span>
                <span className="button-text">Link 2</span>
              </button>
            </Link>
            <br />
            <span className="tagline mt-2 ">Legend League</span>
            <br />
            <Link
              to="https://link.clashofclans.com/en?action=OpenLayout&id=TH15%3AHV%3AAAAADAAAAAJYQ7D4uwEvqczzGRulSJn-"
              target="_blank"
            >
              <button className="learn-more mb-2">
                <span className="hcircle" aria-hidden="true">
                  <span className="icon arrow"></span>
                </span>
                <span className="button-text">Link</span>
              </button>
            </Link>
            <br />
            <span className="tagline mt-2 ">CWL Base</span>
            <br />
            <Link
              to="https://link.clashofclans.com/en?action=OpenLayout&id=TH15%3AWB%3AAAAAHAAAAAJAMSdFBbLVyc8Ovc6QgAyI"
              target="_blank"
            >
              <button className="learn-more mb-2">
                <span className="hcircle" aria-hidden="true">
                  <span className="icon arrow"></span>
                </span>
                <span className="button-text">Link</span>
              </button>
            </Link>
            <br />
            <span className="tagline mt-2">Farming Base</span>
            <br />
            <Link
              to="https://link.clashofclans.com/en?action=OpenLayout&id=TH15%3AHV%3AAAAADAAAAAJX9XSaLhKlDxErY1CVXjrl"
              target="_blank"
            >
              <button className="learn-more mb-2">
                <span className="hcircle" aria-hidden="true">
                  <span className="icon arrow"></span>
                </span>
                <span className="button-text">Link</span>
              </button>
            </Link>
            <br />
          </Col>
        </Row>
        <Row className="align-items-center mt-5">
          <div className="headline text-center">
            <button className="thlbtn">TownHall 14</button>
          </div>
          <Col xs={12} md={6} xl={7} className="px-5" data-aos="fade-up">
            <span className="tagline mt-4 ">War Base</span>
            <br />
            <Link
              to="https://link.clashofclans.com/en?action=OpenLayout&id=TH14%3AWB%3AAAAANQAAAAIHBH9CNWZrX0wyMMk7g52"
              target="_blank"
            >
              <button className="learn-more mb-2">
                <span className="hcircle" aria-hidden="true">
                  <span className="icon arrow"></span>
                </span>
                <span className="button-text">Link 1</span>
              </button>
            </Link>
            <br />

            <Link
              to="https://link.clashofclans.com/en?action=OpenLayout&id=TH14%3AWB%3AAAAANQAAAAIHBIGKRaM2lrESy9ChrFiV"
              target="_blank"
            >
              <button className="learn-more mb-2">
                <span className="hcircle" aria-hidden="true">
                  <span className="icon arrow"></span>
                </span>
                <span className="button-text">Link 2</span>
              </button>
            </Link>
            <br />
            <span className="tagline mt-2 ">Legend Base</span>
            <br />
            <Link
              to="https://link.clashofclans.com/en?action=OpenLayout&id=TH14%3AHV%3AAAAASgAAAAGzcZarVZZqEgmopVQqjjNs"
              target="_blank"
            >
              <button className="learn-more mb-2">
                <span className="hcircle" aria-hidden="true">
                  <span className="icon arrow"></span>
                </span>
                <span className="button-text">Link</span>
              </button>
            </Link>
            <br />
            <span className="tagline mt-2 ">CWL Base</span>
            <br />
            <Link
              to="https://link.clashofclans.com/en?action=OpenLayout&id=TH14%3AHV%3AAAAATQAAAAGUwp2nQXCgqGDg-Gyy-qh_"
              target="_blank"
            >
              <button className="learn-more mb-2">
                <span className="hcircle" aria-hidden="true">
                  <span className="icon arrow"></span>
                </span>
                <span className="button-text">Link</span>
              </button>
            </Link>
            <br />
            <span className="tagline mt-2">Farming Base</span>
            <br />
            <Link
              to="https://link.clashofclans.com/en?action=OpenLayout&id=TH14%3AHV%3AAAAASgAAAAGw4evaSakBGkZkjF9r-OVI"
              target="_blank"
            >
              <button className="learn-more mb-2">
                <span className="hcircle" aria-hidden="true">
                  <span className="icon arrow"></span>
                </span>
                <span className="button-text">Link</span>
              </button>
            </Link>
            <br />
          </Col>
          <Col xs={12} md={6} xl={5} className="mt-2" data-aos="fade-up">
            <img src={townhall14} alt="Header img" />
          </Col>
        </Row>

        <Row className="align-items-center">
          <div className="headline text-center mt-5 ">
            <button className="thlbtn">TownHall 13</button>
          </div>
          <Col xs={12} md={6} xl={5} data-aos="fade-up">
            <img src={townhall13} alt="Header img" />
          </Col>
          <Col xs={12} md={6} xl={7} className="px-5" data-aos="fade-up">
            <span className="tagline mt-4 ">War Base</span>
            <br />
            <Link
              to="https://link.clashofclans.com/en?action=OpenLayout&id=TH13%3AHV%3AAAAAAQAAAAKa_V6_4613K_z60Ws5zXm-"
              target="_blank"
            >
              <button className="learn-more mb-2">
                <span className="hcircle" aria-hidden="true">
                  <span className="icon arrow"></span>
                </span>
                <span className="button-text">Link 1</span>
              </button>
            </Link>
            <br />

            <Link
              to="https://link.clashofclans.com/en?action=OpenLayout&id=TH13%3AHV%3AAAAAAQAAAAKa_X3RLgLNcfQepBoZxorm"
              target="_blank"
            >
              <button className="learn-more mb-2">
                <span className="hcircle" aria-hidden="true">
                  <span className="icon arrow"></span>
                </span>
                <span className="button-text">Link 2</span>
              </button>
            </Link>
            <br />

            <span className="tagline mt-2 ">CWL Base</span>
            <br />
            <Link
              to="https://link.clashofclans.com/en?action=OpenLayout&id=TH13%3AWB%3AAAAAQgAAAAHjUivoYN_H9xxTX-9dksl-"
              target="_blank"
            >
              <button className="learn-more mb-2">
                <span className="hcircle" aria-hidden="true">
                  <span className="icon arrow"></span>
                </span>
                <span className="button-text">Link</span>
              </button>
            </Link>
            <br />
            <span className="tagline mt-2">Farming Base</span>
            <br />
            <Link
              to="https://link.clashofclans.com/en?action=OpenLayout&id=TH13%3AHV%3AAAAAAQAAAAKbwSuCoysoKHBkGXK5SbBJ"
              target="_blank"
            >
              <button className="learn-more mb-2">
                <span className="hcircle" aria-hidden="true">
                  <span className="icon arrow"></span>
                </span>
                <span className="button-text">Link</span>
              </button>
            </Link>
            <br />
          </Col>
        </Row>
        <Row className="align-items-center mt-5">
          <div className="headline text-center">
            <button className="thlbtn">TownHall 12</button>
          </div>
          <Col xs={12} md={6} xl={7} className="px-5" data-aos="fade-up">
            <span className="tagline mt-4 ">War Base</span>
            <br />
            <Link
              to="https://link.clashofclans.com/en?action=OpenLayout&id=TH12%3AWB%3AAAAAMQAAAAITGHgx8PLWdshZOa70zDXw"
              target="_blank"
            >
              <button className="learn-more mb-2">
                <span className="hcircle" aria-hidden="true">
                  <span className="icon arrow"></span>
                </span>
                <span className="button-text">Link 1</span>
              </button>
            </Link>
            <br />

            <Link
              to="https://link.clashofclans.com/en?action=OpenLayout&id=TH12%3AWB%3AAAAAMQAAAAITF2WQJmshIJnxUwo8RSJ9"
              target="_blank"
            >
              <button className="learn-more mb-2">
                <span className="hcircle" aria-hidden="true">
                  <span className="icon arrow"></span>
                </span>
                <span className="button-text">Link 2</span>
              </button>
            </Link>
            <br />

            <span className="tagline mt-2 ">CWL Base</span>
            <br />
            <Link
              to="https://link.clashofclans.com/en?action=OpenLayout&id=TH13%3AWB%3AAAAAQgAAAAHjUivoYN_H9xxTX-9dksl-"
              target="_blank"
            >
              <button className="learn-more mb-2">
                <span className="hcircle" aria-hidden="true">
                  <span className="icon arrow"></span>
                </span>
                <span className="button-text">Link</span>
              </button>
            </Link>
            <br />
            <span className="tagline mt-2">Farming Base</span>
            <br />
            <Link
              to="https://link.clashofclans.com/en?action=OpenLayout&id=TH12%3AHV%3AAAAAEgAAAAJMsY0DaNOuY39T6Qt-qudd"
              target="_blank"
            >
              <button className="learn-more mb-2">
                <span className="hcircle" aria-hidden="true">
                  <span className="icon arrow"></span>
                </span>
                <span className="button-text">Link</span>
              </button>
            </Link>
            <br />
          </Col>
          <Col xs={12} md={6} xl={5} data-aos="fade-up" className="mt-3">
            <img src={townhall12} alt="Header img" />
          </Col>
        </Row>

        <Row className="align-items-center">
          <div className="headline text-center mt-5 mb-5">
            <button className="thlbtn">TownHall 11</button>
          </div>
          <Col xs={12} md={6} xl={5} data-aos="fade-up">
            <img src={townhall11} alt="Header img" />
          </Col>
          <Col xs={12} md={6} xl={7} className="px-5 mt-3" data-aos="fade-up">
            <span className="tagline mt-4 ">War Base</span>
            <br />
            <Link
              to="https://link.clashofclans.com/en?action=OpenLayout&id=TH11%3AHV%3AAAAADgAAAAJQe3wafUPYTXmemiNtJ2_a"
              target="_blank"
            >
              <button className="learn-more mb-2">
                <span className="hcircle" aria-hidden="true">
                  <span className="icon arrow"></span>
                </span>
                <span className="button-text">Link 1</span>
              </button>
            </Link>
            <br />

            <Link
              to="https://link.clashofclans.com/en?action=OpenLayout&id=TH11%3AHV%3AAAAADgAAAAJQe4KWXHgEv73ikw0EuIei"
              target="_blank"
            >
              <button className="learn-more mb-2">
                <span className="hcircle" aria-hidden="true">
                  <span className="icon arrow"></span>
                </span>
                <span className="button-text">Link 2</span>
              </button>
            </Link>

            <br />
            <span className="tagline mt-2">Farming Base</span>
            <br />
            <Link
              to="https://link.clashofclans.com/en?action=OpenLayout&id=TH11%3AHV%3AAAAAVAAAAAFbKSStOa3EyrrdxFfMJY7B"
              target="_blank"
            >
              <button className="learn-more mb-2">
                <span className="hcircle" aria-hidden="true">
                  <span className="icon arrow"></span>
                </span>
                <span className="button-text">Link 1</span>
              </button>
            </Link>
            <br />
            <Link
              to="https://link.clashofclans.com/en?action=OpenLayout&id=TH11%3AHV%3AAAAAVAAAAAFbQm5BCVcnbqosfvmE4wHg"
              target="_blank"
            >
              <button className="learn-more mb-2">
                <span className="hcircle" aria-hidden="true">
                  <span className="icon arrow"></span>
                </span>
                <span className="button-text">Link 2</span>
              </button>
            </Link>
            <br />
          </Col>
        </Row>

        <Row className="align-items-center mt-5">
          <div className="headline text-center">
            <button className="thlbtn">TownHall 10</button>
          </div>
          <Col xs={12} md={6} xl={7} className="px-5" data-aos="fade-up">
            <span className="tagline mt-4 ">War Base</span>
            <br />
            <Link
              to="https://link.clashofclans.com/en?action=OpenLayout&id=TH10%3AWB%3AAAAAMAAAAAIAozoUu-2-8y33ZP6ZRcXY"
              target="_blank"
            >
              <button className="learn-more mb-2">
                <span className="hcircle" aria-hidden="true">
                  <span className="icon arrow"></span>
                </span>
                <span className="button-text">Link 1</span>
              </button>
            </Link>
            <br />

            <Link
              to="https://link.clashofclans.com/en?action=OpenLayout&id=TH10%3AWB%3AAAAAMAAAAAIAo1JT4vGLMtvzfuOSIOoX
              "
              target="_blank"
            >
              <button className="learn-more mb-2">
                <span className="hcircle" aria-hidden="true">
                  <span className="icon arrow"></span>
                </span>
                <span className="button-text">Link 2</span>
              </button>
            </Link>

            <br />
            <span className="tagline mt-2">Farming Base</span>
            <br />
            <Link
              to="https://link.clashofclans.com/en?action=OpenLayout&id=TH10%3AHV%3AAAAADQAAAAJUWB6DJjmUUVSNYnEYs6a4"
              target="_blank"
            >
              <button className="learn-more mb-2">
                <span className="hcircle" aria-hidden="true">
                  <span className="icon arrow"></span>
                </span>
                <span className="button-text">Link 1</span>
              </button>
            </Link>
            <br />
            <Link
              to="https://link.clashofclans.com/en?action=OpenLayout&id=TH10%3AHV%3AAAAADQAAAAJUWAuQQUxi3LNNqXIOEc4j"
              target="_blank"
            >
              <button className="learn-more mb-2">
                <span className="hcircle" aria-hidden="true">
                  <span className="icon arrow"></span>
                </span>
                <span className="button-text">Link 2</span>
              </button>
            </Link>
            <br />
          </Col>
          <Col xs={12} md={6} xl={5} data-aos="fade-up" className="mt-3">
            <img src={townhall10} alt="Header img" />
          </Col>
        </Row>

        <Row className="align-items-center mb-5">
          <div className="headline text-center mt-4">
            <button className="thlbtn mt-4 mb-2">TownHall 9</button>
          </div>
          <Col xs={12} md={6} xl={5} data-aos="fade-up">
            <img src={townhall9} alt="Header img" />
          </Col>
          <Col xs={12} md={6} xl={7} className="px-5" data-aos="fade-up">
            <span className="tagline mt-4 ">War Base</span>
            <br />
            <Link
              to="https://link.clashofclans.com/en?action=OpenLayout&id=TH9%3AWB%3AAAAAVAAAAAGGSomBmpyLtO_7pW9-jsav"
              target="_blank"
            >
              <button className="learn-more mb-2">
                <span className="hcircle" aria-hidden="true">
                  <span className="icon arrow"></span>
                </span>
                <span className="button-text">Link 1</span>
              </button>
            </Link>
            <br />

            <Link
              to="https://link.clashofclans.com/en?action=OpenLayout&id=TH9%3AWB%3AAAAAVAAAAAGGSnJ8JhSn1RHkp_vPOvQD"
              target="_blank"
            >
              <button className="learn-more mb-2">
                <span className="hcircle" aria-hidden="true">
                  <span className="icon arrow"></span>
                </span>
                <span className="button-text">Link 2</span>
              </button>
            </Link>
            <br />

            <span className="tagline mt-2">Forming Base</span>
            <br />
            <Link
              to="https://link.clashofclans.com/en?action=OpenLayout&id=TH9%3AHV%3AAAAATwAAAAGMldHsw7ZOGJPimxeJST7y"
              target="_blank"
            >
              <button className="learn-more mb-2">
                <span className="hcircle" aria-hidden="true">
                  <span className="icon arrow"></span>
                </span>
                <span className="button-text">Link</span>
              </button>
            </Link>
            <br />
          </Col>
        </Row>
      </Container>
    </section>
  );
}
